import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl } from '@angular/forms';
import { Observable, of, Subject } from 'rxjs';
import {
  catchError,
  debounceTime,
  map,
  skipWhile,
  switchMap
} from 'rxjs/operators';

export interface GiphyImage {
  url: string;
}

export interface Giphy {
  type: string;
  title: string;
  images: {
    downsized: GiphyImage;
    downsized_medium: GiphyImage;
    downsized_small: GiphyImage;
  };
}

export interface GiphyResponse {
  data: Giphy[];
}

@Component({
  selector: 'anms-giphy',
  templateUrl: './giphy.component.html',
  styleUrls: ['./giphy.component.scss']
})
export class GiphyComponent implements OnInit, OnDestroy {
  @Output() selectedGiphy = new EventEmitter<Giphy>();

  giphySearch = new FormControl('', []);
  unSubscribe = new Subject();

  giphySearch$: Observable<Giphy[]>;

  constructor(private httpClient: HttpClient) {}

  ngOnInit(): void {
    this.giphySearch$ = this.giphySearch.valueChanges.pipe(
      skipWhile(v => !v),
      debounceTime(200),
      switchMap(value =>
        this.getGiphy(value).pipe(
          map(re => re.data),
          catchError(_ => of([]))
        )
      )
    );
  }

  getGiphy(value: string): Observable<GiphyResponse> {
    const phrase = encodeURIComponent(value);
    return this.httpClient.get<GiphyResponse>(
      `https://api.giphy.com/v1/gifs/search?api_key=XsKpGcbt63ZBWCQ5cNqUNrUg9HUUiymc&q=${phrase}`
    );
  }

  selectGiphy(giphy: Giphy): void {
    this.selectedGiphy.emit(giphy);
  }

  ngOnDestroy() {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }
}
